// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".alert[data-v-ccb679d4] {\n  margin-bottom: 20px;\n}", ""]);
// Exports
module.exports = exports;
